import React, { useEffect, useRef } from "react";
import { useStyles } from "./styles";
import { InputElement } from "../models/IDynamicForm";
import FormControl from "@material-ui/core/FormControl";
import { useTheme } from "@material-ui/core/styles";
import { connect } from "react-redux";
import {
  getUrl,
  applyDependencies,
  applyInitialDependencies,
  applySimpleCondition,
  getDependencies,
  getMask,
  validarDato,
  dependenciaCondicional,
  getAsyncData,
  getOptionsFromGroup,
} from "./Operations";
import _ from "lodash";
import FormLabel from "@material-ui/core/FormLabel";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { useField } from "react-final-form";
import { useContext } from "react";
import { ctxts } from "../DynamicFormContext";
const fullWidthOp = false;

const CheckBoxes = (props) => {
  const classes = useStyles();
  const inputelement: InputElement = props.inputelement;
  const {
    label,
    input,
    meta: { touched, invalid, error },
    name,
    meta,
    values,
    ...customs
  } = props;
  const { tramiteId, loadingAsyncData, isTableView, isLastPaso, ...custom } =
    customs;
  const showField = useField(input.name + "_selectedOption");
  const theme = useTheme();
  const [value, setValue] = React.useState(
    _.get(values, input.name)
      ? _.get(values, input.name)
      : meta.initial
      ? meta.initial
      : []
  );
  const context = useContext(ctxts);
  //#region  //? Condicional  visible o no config
  const [visible, setVisible] = React.useState(
    inputelement.isConditional ? false : true
  );

  const [urlCondition, setUrlCondition] = React.useState("");
  useEffect(() => {
    if (inputelement.isConditional && inputelement.conditional?.asyncData) {
      dependenciaCondicional(inputelement, urlCondition, setVisible, props);
    }
  }, [urlCondition]);
  //#endregion
  //#region //! actualizar  urls
  //? con estas dependencias y useEffect recalculo las urls
  //? solo cuando cambien los valores de los inputs que la url requiere
  const mountedRef = useRef(true);
  const [url, setUrl] = React.useState("");
  const getArrayDependecies = () => {
    const dependencias = getDependencies(input, inputelement);
    return [
      dependencias.map((d) => {
        const dependenciaValue = _.get(values, d);
        return dependenciaValue ? dependenciaValue : "";
      }),
    ];
  };
  useEffect(() => {
    if (inputelement.asyncData) {
      setUrl(
        getUrl(
          input.name,
          inputelement.asyncConf.url,
          props.cuit,
          values,
          inputelement.asyncConf.JsonFieldsName,
          null,
          inputelement.asyncConf.baseUrl,
          context.BaseUrls
        )
      );
    }
    if (inputelement.isConditional && inputelement.conditional?.asyncData) {
      setUrlCondition(
        getUrl(
          input.name,
          inputelement.conditional.asyncConf.url,
          props.cuit,
          values,
          inputelement.conditional.asyncConf.JsonFieldsName,
          null,

          inputelement.conditional.asyncConf.baseUrl,
          context.BaseUrls
        )
      );
    }
  }, [...getArrayDependecies()]);
  //#endregion
  //#region //? validaciones asyncronas
  const [msj, setMsj] = React.useState({
    show: false,
    type: "error",
    msj: inputelement.asyncValidationConf?.errorMsg,
  });

  const validar = () =>
    validarDato(inputelement, input, props, values, setMsj, context.BaseUrls);
  //#endregion
  //#region  //? calculos entre campos
  useEffect(() => {
    applyDependencies(props);
    if (
      inputelement.isConditional &&
      inputelement.conditional &&
      !inputelement.conditional.asyncData
    ) {
      setVisible(applySimpleCondition(props));
    }
  });
  //#endregion

  useEffect(() => {
    if (!props.isLastPaso) return;
    if (inputelement.optionsFromGroup) {
      const response = getOptionsFromGroup(
        inputelement.optionsConfig.groupName,
        values
      );
      if (response) {
        setOptions(
          Array.isArray(response)
            ? response.map((elem) => {
                return {
                  text: _.get(elem, inputelement.optionsConfig.propertyText),
                  value: _.get(elem, inputelement.optionsConfig.propertyValue),
                };
              })
            : []
        );
      }
    }
  }, [_.get(values, inputelement?.optionsConfig?.groupName)]); //se ejecuta solo si la url cambia
  const dependencias = getDependencies(input, inputelement);
  const focusedInput = props.appContext.inputFocus;
  //#region //?traer datos asincronos
  useEffect(() => {
    if (!props.isLastPaso) return;
    if (
      inputelement.asyncData &&
      !dependencias.some((d) => d === props.appContext.inputFocus)
    ) {
      const response = getAsyncData(inputelement, url, props, input);
      response.then((res) => {
        if (!mountedRef.current) return null;
        if (res) {
          const data = _.get(
            res,
            inputelement.asyncConf.baseNode
              ? inputelement.asyncConf.baseNode
              : "data"
          );

          setOptions(
            Array.isArray(data)
              ? data.map((elem) => {
                  return {
                    text: _.get(elem, inputelement.asyncConf.propertyText),
                    value: _.get(elem, inputelement.asyncConf.propertyValue),
                  };
                })
              : []
          );
        }
      });
    }
  }, [url, focusedInput]); //se ejecuta solo si la url cambia
  //#endregion
  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //#region //? inicializar el componente
  useEffect(() => {
    applyInitialDependencies(props);
  }, [
    inputelement.dependsOn ? _.get(values, inputelement.dependsOn[0]) : null,
  ]);
  //#endregion

  const [options, setOptions] = React.useState(
    inputelement.options?.length > 0
      ? inputelement.options
      : showField.input.value
      ? [showField.input.value]
      : [
          {
            text: "No hay opciones configuradas",
            value: "No hay opciones configuradas",
          },
        ]
  );
  const handleChange = (event) => {
    //console.log("handleCHange" + event.target);
    //  setValue(event.target.value);
    //  @todo ver si la respuesta tipo array funciona o mandar string.
    let valores = [];
    valores.push(...value);
    if (event.target.checked) {
      valores.push(event.target.value);
    } else {
      valores.splice(valores.indexOf(event.target.value), 1);
    }
    setValue(valores);

    //console.log("values: " + valores)
    input.onChange(valores);
  };

  if (visible) {
    return (
      <FormControl component="fieldset" className={classes.formcontrol}>
        <FormLabel component="legend">{inputelement.label}</FormLabel>
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            control={
              <Checkbox
                value={option.value}
                disabled={inputelement.disabled || props.disabled}
                color="primary"
                // {...input}
                checked={
                  Array.isArray(input.value) && input.value.length > 0
                    ? input.value.find((v) => v === option.value)
                      ? true
                      : false
                    : false
                }
                onChange={(event: any) => {
                  handleChange(event);
                }}
              />
            }
            label={option.text}
          />
        ))}
        {props.meta.touched && error && (
          <span style={{ color: "red" }}>{error}</span>
        )}
      </FormControl>
    );
  } else {
    return null;
  }
};

const mapState = (state) => ({
  cuit: state.auth.cuit,
  jwt: state.auth.jwt,
});

const mapDispatch = (dispatch) => ({});

export default connect(mapState, mapDispatch)(CheckBoxes);
